import { Link } from "react-router-dom";
import { categoryList, siteInfo } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-accent-100 border-t border-accent-200/80">
      <div className="w-full px-5 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-radar-line text-lg" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              {siteInfo.description}
            </p>
            <p className="mt-4 text-sm text-foreground-600">
              <i className="ri-mail-line mr-1.5" />
              {siteInfo.email}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">站点导航</h4>
            <ul className="space-y-2.5 text-sm text-foreground-700">
              <li>
                <Link to="/" className="hover:text-primary-700 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/events" className="hover:text-primary-700 cursor-pointer">
                  事件追踪总览
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-primary-700 cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-primary-700 cursor-pointer">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">事件分类</h4>
            <ul className="space-y-2.5 text-sm text-foreground-700">
              {categoryList.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/events?cat=${cat.key}`}
                    className="hover:text-primary-700 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-accent-300/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-foreground-600">
          <p>
            © {siteInfo.since}-{year} {siteInfo.name} · 内容以公开信息整理，供读者参考
          </p>
          <p className="whitespace-nowrap">{siteInfo.domain}</p>
        </div>
      </div>
    </footer>
  );
}